<template>
  <div class="assignment-details-tile assignment-details-tile__control">
    {{ company.Name }}
    <span v-if="company.IsMainCompany" class="main-company">[Main]</span>

    <br />
    <span class="assignment-details-tile__control-header"> RC: </span>
    <span v-if="allowEmail" class="rc-email-action" @click="onSendEmailClicked">
      {{ company.Rc }}
    </span>
    <span v-else>
      {{ company.Rc }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { CompanyDisplay } from "@/Domain/CompanyDisplay";

const props = defineProps<{
  company: CompanyDisplay;
  allowEmail?: boolean;
}>();

const emit = defineEmits<{
  (e: "sendEmailClicked", assignment: CompanyDisplay): void;
}>();

const onSendEmailClicked = function () {
  emit("sendEmailClicked", props.company);
};
</script>

<style scoped lang="scss">
.assignment-details-tile {
  border: 0.5px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f9f9f9;

  .main-company {
    font-size: 0.8em;
    color: green;
    margin-left: 5px;
  }

  &__header {
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__control {
    //display: flex;
    display: block;
    gap: 8px;

    &-header {
      font-weight: bold;
    }

    &-text {
      color: #666;
    }
  }

  .rc-email-action {
    color: #337ab7;
    cursor: pointer;
  }
}
</style>
